/**
 * Chart-related constants shared across components
 */

// Color palette for multiple series
export const SERIES_COLORS = [
  "hsl(188, 100%, 42%)", // Signal Cyan #00B8D4 — data viz
  "#10b981", // Green
  "#d946ef", // Fuchsia — readable on light cards and dark panels; not a status tint
  "#8b5cf6", // Purple
  "#ef4444", // Red
  "#06b6d4", // Cyan
  "#f97316", // Orange
  "#6366f1", // Indigo
];

// Downtime overlay colors
export const DOWNTIME_COLORS = {
  background: "rgba(239, 68, 68, 0.2)",
  line: "#ef4444",
  annotation: "#ef4444",
};

// Time range options
export const TIME_RANGE_OPTIONS = ["24 Hours", "7 Days", "30 Days", "Custom"];

// Performance constants
export const MOUSE_THROTTLE_MS = 50;
export const ANNOTATION_OFFSET_PX = 10;
export const MAX_LABEL_LENGTH = 30;

/** Maximum number of tags that can be selected for trend graphing at once */
export const MAX_SELECTED_GRAPH_TAGS = 20;

/**
 * @deprecated Kept for reference; trend chart now uses axis margin + slot below x-axis.
 * Was a fixed gap below the plot, which overlapped datetime tick labels when margin was tight.
 */
export const DOWNTIME_STRIP_GAP_BELOW_PLOT_PX = 35;

/** Bottom margin reserved for the trend chart x-axis (single Y-axis). */
export const TREND_X_AXIS_MARGIN_SINGLE = 52;
/** Bottom margin reserved for the trend chart x-axis (multiple Y-axes). */
export const TREND_X_AXIS_MARGIN_MULTI = 64;
/**
 * Extra bottom margin when downtime HTML chips are shown (below x-axis tick labels).
 * Large enough for hovered annotations (multi-line start/end/duration + scale).
 */
export const DOWNTIME_HTML_LABEL_SLOT_PX = 140;
